"use client";
import Image from "next/image";
import { FaCalendar } from "react-icons/fa";
import { ImArrowUpRight2 } from "react-icons/im";
import { IoChevronDown } from "react-icons/io5";
import dynamic from "next/dynamic";

import React, { useEffect, useState } from "react";
const Pagination = dynamic(() => import("antd/es/pagination"), { ssr: false });
const Spin = dynamic(() => import("antd/es/spin"), { ssr: false });
const Empty = dynamic(() => import("antd/es/empty"), { ssr: false });
import Link from "next/link";
import CommonService from "@/services/api/CommonService";

import { motion } from "framer-motion";

export default function NoticesPage() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const fetchNotices = async (page = 1) => {
    setLoading(true);
    try {
      const res = await CommonService.getNotices({ page, per_page: pageSize });
      if (res?.data) {
        setNotices(res.data);
        setTotalItems(res.total || 0);
        setCurrentPage(res.current_page || page);
        setPageSize(res.per_page || pageSize);
      }
    } catch (err) {
      console.error("Error fetching notices:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotices(currentPage);
  }, [currentPage]);

  return (
    <section className="notices-page bg-animation section_padding">
      <div className="container">
        <div className="section_title">
          <h1 className="title">
            <span className="relative w-8 h-8">
              <Image
                src="/images/admission-icon/information_icon.png"
                className="img-icon"
                alt="Book Icon"
                fill
              />
            </span>
            নোটিশ বোর্ড
          </h1>
        </div>
        <div className="section-content-wrap">
          <div className="grid grid-cols-12 md:gap-6 gap-4">
            <div className="xl:col-span-8 lg:col-span-7 col-span-12">
              <div className="all-notice-card">
                <div className="top-title">
                  <h2 className="title">সকল নোটিশ</h2>
                </div>
                <div className="notice-wrap">
                  {loading ? (
                    <div className="text-center py-8">
                      <Spin size="large" />
                    </div>
                  ) : notices.length === 0 ? (
                    <Empty
                      description="কোনো নোটিশ পাওয়া যায়নি।"
                      className="py-10"
                    />
                  ) : (
                    <>
                      {notices.map((notice, index) => (
                        <Link
                          href={`/notice-board/${notice.slug || notice.id}`}
                          key={index}
                        >
                          <div className="notice-item">
                            <div className="empty">
                              <div className="icon-wrap">
                                <ImArrowUpRight2 />
                              </div>
                            </div>
                            <div className="notice-text">
                              <h3 className="notice">{notice.name}</h3>
                              <p className="date">
                                <FaCalendar /> {notice.date}
                              </p>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </>
                  )}

                  <div className="md:mt-6 mt-4">
                    {totalItems > pageSize && (
                      <div className="fa-pagination">
                        <Pagination
                          current={currentPage}
                          pageSize={pageSize}
                          total={totalItems}
                          onChange={(page) => setCurrentPage(page)}
                          showSizeChanger={false}
                          itemRender={(page, type, originalElement) => {
                            if (type === "prev") {
                              return (
                                <a>
                                  <ArrowLeft />
                                </a>
                              );
                            }
                            if (type === "next") {
                              return (
                                <a>
                                  <ArrowRight />
                                </a>
                              );
                            }
                            return originalElement;
                          }}
                        />
                      </div>
                    )}

                    {/* <Link href="/courses/all" className="seemore-btn">
                      আরো পড়ুন <IoChevronDown />
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="xl:col-span-4 lg:col-span-5 col-span-12">
              <div className="all-notice-card">
                <div className="top-title">
                  <h2 className="title">আপডেটেড নোটিশ</h2>
                </div>
                <div className="notice-wrap">
                  <div className="notice-scroll-wrap">
                    {notices?.map((notice,index) => (
                      <Link
                        href={`/notice-board/${notice.slug || notice.id}`}
                        key={index}
                      >
                        <div className="notice-item">
                          <div className="empty">
                            <div className="icon-wrap">
                              <ImArrowUpRight2 />
                            </div>
                          </div>
                          <div className="notice-text">
                            <h3 className="notice">{notice.name} </h3>
                            <p className="date">
                              <FaCalendar />
                              {notice.date}
                            </p>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
